export const LONG_TEXT_MAX_CHAR_LIMIT = 1000;
